import { useEffect } from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTicketCustomerInfo } from '../../../../state';
import { useGraphProfile } from '../../../../hooks';

const CustomerDepartmentEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentTicket } = useAppSelector(state => state.ticket);
  const { graphData } = useGraphProfile();

  useEffect(() => {
    if (graphData?.department && !currentTicket?.customerInfo.customerDepartment) {
      dispatch(updateTicketCustomerInfo({ customerDepartment: graphData.department }));
    }
  }, [dispatch, graphData, currentTicket?.customerInfo.customerDepartment]);

  return (
    <TextField
      label="Department"
      size="small"
      fullWidth
      value={currentTicket?.customerInfo.customerDepartment || ''}
      placeholder="Auto-populated from user profile"
      disabled={true}
    />
  );
};

export default CustomerDepartmentEdit;
